import { useState } from "react";
import { motion } from "framer-motion";
import { MoveHorizontal } from "lucide-react";

export const CompareSlider = ({ before, after, title }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="relative aspect-[4/3] sm:aspect-[16/10] rounded-[2rem] overflow-hidden select-none bg-[#0F2317]" data-testid="compare-slider">
      <img src={after} alt={`${title} — dopo`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <img src={before} alt={`${title} — prima`} className="absolute inset-0 w-full h-full object-cover" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} draggable={false} />
      <span className="absolute top-5 left-5 rounded-full bg-[#0F2317]/70 backdrop-blur px-3 py-1.5 f-mono text-xs tracking-[0.2em] uppercase text-[#FCFBF7]">Prima</span>
      <span className="absolute top-5 right-5 rounded-full bg-[#86C89B] px-3 py-1.5 f-mono text-xs tracking-[0.2em] uppercase text-[#0F2317]">Dopo</span>
      <div className="absolute top-0 bottom-0 w-px bg-[#FCFBF7] shadow-[0_0_20px_rgba(134,200,155,0.9)] pointer-events-none" style={{ left: `${pos}%` }}>
        <motion.span
          initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 grid place-items-center w-12 h-12 rounded-full bg-[#FCFBF7] text-[#1B3B28] shadow-xl"
        >
          <MoveHorizontal size={20} />
        </motion.span>
      </div>
      <input
        type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Confronta prima e dopo" data-testid="compare-slider-input"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
      />
    </div>
  );
};
